import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { RichTextField } from './RichTextField';
import { Plus, X } from 'lucide-react';

interface Slide {
  description: string;
}

interface SlidesListInputProps {
  value?: Slide[];
  onChange: (_slides: Slide[]) => void;
  placeholder?: string;
}

export const SlidesListInput: React.FC<SlidesListInputProps> = ({
  value = [],
  onChange,
}) => {
  const [slides, setSlides] = useState<Slide[]>(value);

  useEffect(() => {
    setSlides(value);
  }, [value]);

  const addSlide = () => {
    const newSlide: Slide = { description: '' };
    const updatedSlides = [...slides, newSlide];
    setSlides(updatedSlides);
    onChange(updatedSlides);
  };

  const removeSlide = (index: number) => {
    const updatedSlides = slides.filter((_, i) => i !== index);
    setSlides(updatedSlides);
    onChange(updatedSlides);
  };

  const updateSlide = (index: number, field: keyof Slide, value: string) => {
    const updatedSlides = slides.map((slide, i) => 
      i === index ? { ...slide, [field]: value } : slide
    );
    setSlides(updatedSlides);
    onChange(updatedSlides);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={addSlide}
          className="flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Adicionar Slide
        </Button>
      </div>
      
      {slides.length === 0 ? (
        <div className="text-center py-4 text-gray-500 text-sm border-2 border-dashed border-gray-200 rounded-lg">
          Nenhum slide adicionado
        </div>
      ) : (
        <div className="space-y-4">
          {slides.map((slide, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4 bg-white">
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-sm font-semibold text-gray-700">
                  Slide {index + 1}
                </h4>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => removeSlide(index)}
                  className="text-red-500 hover:text-red-700 hover:bg-red-50"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
              <div>
                <RichTextField
                  label="Descrição"
                  value={slide.description}
                  onChange={(value: string) => updateSlide(index, 'description', value)}
                  placeholder="Digite a descrição do slide"
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

